var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48593 9.70269C7.64111 10.326 6.59674 10.6944 5.46633 10.6944C2.65447 10.6944 0.375 8.41491 0.375 5.60305C0.375 2.79118 2.65447 0.511719 5.46633 0.511719C8.27819 0.511719 10.5577 2.79118 10.5577 5.60305C10.5577 6.73347 10.1893 7.77784 9.56596 8.62266L13.1303 12.187C13.4286 12.4853 13.4286 12.9688 13.1303 13.2671C12.8321 13.5653 12.3485 13.5653 12.0503 13.2671L8.48593 9.70269ZM9.53939 5.60305C9.53939 7.85254 7.71582 9.67611 5.46633 9.67611C3.21684 9.67611 1.39327 7.85254 1.39327 5.60305C1.39327 3.35356 3.21684 1.52998 5.46633 1.52998C7.71582 1.52998 9.53939 3.35356 9.53939 5.60305Z",
    fill: "#969FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c2d83829732a407c87dc66708f4b550b.svg";
export { ForwardRef as ReactComponent };